import React from "react";
import * as S from "./memoItemBox.styles";
import { ReactComponent as IconMemo } from "../../../styles/assets/svg/icon_memo.svg";

export interface MemoItemBoxProps {
  label?: string;
  content?: string | number;
  contentColor?: string;
}

export const MemoItemBox = ({
  label,
  content,
  contentColor,
}: MemoItemBoxProps) => {
  return (
    <S.ItemMemoBox>
      <S.MemoLabel>
        <IconMemo width={15} height={15} />
        {label || "메모"}
      </S.MemoLabel>

      <div>
        <S.MemoContent contentColor={contentColor}>
          {content ? content : "-"}
        </S.MemoContent>
      </div>
    </S.ItemMemoBox>
  );
};
